module.exports = __webpack_public_path__ + "static/media/10.27348750.mp3";